// Entry point for the build script in your package.json
import "preline";
import Alpine from "alpinejs";
import "@hotwired/turbo-rails";
import "./turbo";
import "./toastify";
import "./controllers";

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

function autoInit() {
  window.HSStaticMethods.autoInit();
  console.log("autoInit");
}

document.addEventListener("turbo:load", () => {
  autoInit();
});

document.addEventListener("turbo:submit-end", (event) => {
  if (!event.detail.success) {
    setTimeout(autoInit, 1);
  }
});


import mask from '@alpinejs/mask'
Alpine.plugin(mask)

Alpine.data("toggleCard", () => ({
  showNextCard: false,
  lastSelected: false,
  toggle(event) {
    console.log("toggle", event);
    if (event.target.closest("[data-hs-carousel]")) {
      return;
    }
    setTimeout(() => {
      if (window.getSelection().toString()) {
        return (this.lastSelected = true);
      }
      if (!this.lastSelected) {
        this.showNextCard = !this.showNextCard;
      }
      this.lastSelected = false;
    }, 1);
  },
}));

document.addEventListener("DOMContentLoaded", () => {
  Alpine.start();
});

window.Alpine = Alpine;